import {
  canGraphExpressions,
  EXPRESSION_COUNT_LIMIT,
  getSelectedExpressions,
} from "@/components/graph/utils";
import { normalizeSuggestionKeywords } from "@/components/suggestions/providers/utils/normalizeKeywords";

import type { SingleSuggestion, SuggestionProvider } from "@/components/suggestions/types";

export const graphSuggestionsProvider: SuggestionProvider = {
  type: "graph",
  search: (_str, doc) => {
    if (!doc.selection.hasActionableSelection) {
      return [];
    }

    const expressions = getSelectedExpressions(doc, EXPRESSION_COUNT_LIMIT);

    if (!canGraphExpressions(expressions, { allowSingleNode: ["function"] })) {
      return [];
    }

    const suggestion: SingleSuggestion<"group"> = {
      type: "single",
      item: {
        type: "group",
        intlName: "makeGraph",
        symbol: "",
      },
      action: {
        type: "insert-graph",
        expressions: expressions.map((expr) => expr.map((node) => node.toJSON())),
      },
      keywords: normalizeSuggestionKeywords({ keywords: ["plot", "chart", "graph"] }),
      icon: "GraphSimple",
      forceIcon: true,
      popupGroup: "graph",
      priority: 1,
    };

    return [[suggestion]];
  },
};
